const TelegramHollowLogo = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
            <path d="M13.6667 7.389L9.44444 11.6112L15.7778 17.9446L20 1.05566L1 8.44455L5.22222 10.5557L7.33333 16.889L10.5 12.6668" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default TelegramHollowLogo;